import {
    object,
    string,
} from 'yup';

export const clientScoringStatusValidationSchema = object().shape({
    comment: string().required().min(15).max(200).label('Comment'),
});




// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/validation-schemas/clientScoringStatusValidationSchema.js